import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Index from "./pages/Index";
import TributePage from "./pages/TributePage";
import AdminLogin from "./pages/AdminLogin";
import AdminTributes from "./pages/AdminTributes";
import AdminTributeForm from "./pages/AdminTributeForm";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import Pricing from "./pages/Pricing";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import SubjectLogin from "./pages/SubjectLogin";
import ComingSoon from "./pages/ComingSoon";
import GetStarted from "./pages/GetStarted";
import Partner from "./pages/Partner";
import DigitalLegacyDirective from "./pages/DigitalLegacyDirective";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import DataSecurity from "./pages/DataSecurity";
import Ethics from "./pages/Ethics";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CaptureGuide from "./pages/CaptureGuide";
import PhotoUpload from "./pages/PhotoUpload";
import ProcessingStatus from "./pages/ProcessingStatus";
import InterviewLanding from "./pages/InterviewLanding";
import Subject from "./pages/Subject";
import CreateTribute from "./pages/CreateTribute";
import BuyerProtectedRoute from "./components/BuyerProtectedRoute";

const queryClient = new QueryClient();

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <SentryRoutes>
          <Route path="/" element={<Index />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/digital-legacy-directive" element={<DigitalLegacyDirective />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/subject-login" element={<SubjectLogin />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/data-security" element={<DataSecurity />} />
          <Route path="/security" element={<Navigate to="/data-security" replace />} />
          <Route path="/ethics" element={<Ethics />} />
          <Route path="/tribute/:slug" element={<TributePage />} />
          <Route path="/capture" element={<CaptureGuide />} />
          <Route path="/upload/:slug" element={<PhotoUpload />} />
          <Route path="/processing/:slug" element={<ProcessingStatus />} />
          <Route path="/interview/:slug" element={<InterviewLanding />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/tributes" element={<ProtectedRoute><AdminTributes /></ProtectedRoute>} />
          <Route path="/admin/tributes/new" element={<ProtectedRoute><AdminTributeForm /></ProtectedRoute>} />
          <Route path="/admin/tributes/:id/edit" element={<ProtectedRoute><AdminTributeForm /></ProtectedRoute>} />
          <Route path="/subject" element={<Subject />} />
          <Route path="/create" element={<BuyerProtectedRoute><CreateTribute /></BuyerProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
